<template>
  <div>
    <div class="fix-wrapper">
      <breadcrumb :crumbs="[$t('menu.cusromerReturns'), $t('text.create')]">
      </breadcrumb>
      <div class="container">
        <el-form
          ref="returnBackForm"
          :model="returnBack"
          label-width="100px"
          size="small"
        >
          <div class="pd20">
            <fieldset>
              <legend>
                {{ $t("text.baseInfo") }}
              </legend>
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item
                    :label="$t('text.serialNo')"
                    :prop="'serialNo'"
                    :rules="[
                      {
                        required: true,
                        validator: validateSerialNo,
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-input
                      size="small"
                      v-model.trim="returnBack.orderSerialNo"
                      :placeholder="$t('prompt.alphabetNumberLine')"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    :label="$t('bargain.customerName')"
                    :prop="'customerName'"
                  >
                    <el-input
                      size="small"
                      v-model.trim="returnBack.customerName"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    :label="$t('bargain.customerPhone')"
                    :prop="'customerPhone'"
                  >
                    <el-input
                      size="small"
                      v-model.trim="returnBack.customerPhone"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item
                    :label="$t('returnBack.returnTracking')"
                    :prop="'returnTracking'"
                  >
                    <el-input
                      size="small"
                      v-model.trim="returnBack.returnTracking"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    :label="$t('returnBack.deliverySerialNo')"
                    :prop="'deliverySerialNo'"
                  >
                    <el-autocomplete
                      v-model.trim="returnBack.deliverySerialNo"
                      :fetch-suggestions="querySearchDeliverySerialNo"
                      :trigger-on-focus="false"
                      style="width: 100%"
                      @select="handleSelectDeliverySerialNo"
                    >
                    </el-autocomplete>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    :label="$t('returnBack.deliceryTracking')"
                    :prop="'deliceryTracking'"
                  >
                    <el-autocomplete
                      v-model.trim="returnBack.deliceryTracking"
                      :fetch-suggestions="querySearchDeliveryTracking"
                      :trigger-on-focus="false"
                      style="width: 100%"
                      @select="handleSelectDeliveryTracking"
                    >
                    </el-autocomplete>
                  </el-form-item>
                </el-col>
              </el-row>
              <fieldset>
                <legend>
                  {{ $t("order.productInfo") }}
                </legend>
                <el-row :gutter="20">
                  <el-col :span="8">
                    <el-form-item
                      :label="$t('product.productNo')"
                      :prop="'productNo'"
                      :rules="[
                        {
                          required: true,
                          message: $t('rules.required', [
                            $t('product.productNo'),
                          ]),
                          trigger: 'blur',
                        },
                      ]"
                    >
                      <el-autocomplete
                        v-model.trim="returnBack.productNo"
                        :fetch-suggestions="querySearchProductNo"
                        :trigger-on-focus="false"
                        style="width: 100%"
                        @select="handleSelectProductNo"
                      >
                        <template slot-scope="{ item }">
                          <div class="name">{{ item.productNo }}</div>
                          <span class="addr">{{ item.productNoAlias }}</span>
                        </template>
                      </el-autocomplete>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('product.size')" :prop="'size'">
                      <el-autocomplete
                        size="small"
                        v-model.trim="returnBack.size"
                        :fetch-suggestions="querySearchSize"
                        style="width: 100%"
                        @select="handleSelectSize"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('product.color')" :prop="'color'">
                      <el-autocomplete
                        size="small"
                        v-model.trim="returnBack.color"
                        :fetch-suggestions="querySearchColor"
                        style="width: 100%"
                        @select="handleSelectColor"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :span="8">
                    <el-form-item
                      :label="$t('text.quantity')"
                      :prop="'quantity'"
                      :rules="[
                        {
                          required: true,
                          message: $t('rules.required', [$t('text.quantity')]),
                          trigger: 'blur',
                        },
                      ]"
                    >
                      <el-input
                        size="small"
                        v-model.trim="returnBack.quantity"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <!-- <el-col :span="8">
                    <el-form-item
                      :label="$t('returnBack.haveGood')"
                      :prop="'haveGood'"
                    >
                      <el-checkbox v-model="returnBack.haveGood"></el-checkbox>
                    </el-form-item>
                  </el-col> -->
                </el-row>
              </fieldset>
            </fieldset>
            <fieldset class="mgb15">
              <legend>
                {{ $t("product.images") }}
              </legend>
              <dropzone v-model="returnBack.images" multiple />
            </fieldset>
            <fieldset>
              <legend>
                {{ $t("text.remark") }}
              </legend>
              <el-input
                size="small"
                v-model.trim="returnBack.remark"
                type="textarea"
                :rows="2"
              ></el-input>
            </fieldset>
          </div>
          <div class="form-footer">
            <el-button
              type="primary"
              plain
              :loading="saveDoing"
              size="medium"
              @click="save()"
              >{{ $t("text.submit") }}</el-button
            >
            <back-button />
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import Util from "@/utils/index.js";
import { page } from "@/utils/mixins.js";
import BackButton from "@/components/BackButton";
import Dropzone from "@/components/Dropzone";

//
import Size from "@/api/size.js";
import Color from "@/api/color.js";
import Product from "@/api/product.js";
import ReturnBack from "@/api/returnBack.js";
import Delivery from "@/api/delivery.js";

export default {
  components: {
    BackButton,
    Dropzone,
  },
  mixins: [page],
  data() {
    var validateSerialNo = (rule, value, callback) => {
      const self = this;
      if (value === null && value === "") {
        callback(
          new Error(self.$t("rules.required", [self.$t("order.serialNo")]))
        );
        return;
      }
      if (!Util.regexAlphabetNumberLine(value)) {
        callback(new Error(this.$t("prompt.regexAlphabetNumberLine")));
        return;
      }
      callback();
    };

    return {
      validateSerialNo: validateSerialNo,
      sizes: [],
      colors: [],
      returnBack: {
        orderSerialNo: null,
        productNo: null,
        color: null,
        size: null,
        quantity: null,
        price: null,
        remark: null,
        haveGood: true,
        customerName: null,
        customerPhone: null,
        deliverySerialNo: null,
        deliceryTracking: null,
        returnTracking: null,
        images: null,
      },
      saveDoing: false,
      //
      products: [],
      productNoColors: [],
      productNoSizes: [],

      deliveries: [],
    };
  },
  mounted() {},
  created() {
    const self = this;
    axios.all([Size.findByTenantId(), Color.findByTenantId()]).then(
      axios.spread(function (sizes, colors) {
        if (sizes.status === 200) {
          self.sizes = sizes.data;
        } else {
          self.sysError();
        }
        if (colors.status === 200) {
          self.colors = colors.data;
        } else {
          self.sysError();
        }
      })
    );
  },

  methods: {
    querySearchDeliveryTracking(queryString, cb) {
      const self = this;
      //
      if (queryString == null || queryString.length < 1) {
        return;
      }
      Delivery.vagueFindByTracking({ tracking: queryString }).then(function (
        res
      ) {
        self.deliveries = res.data;
        if (self.deliveries.length !== 0) {
          for (const p of self.deliveries) {
            Vue.set(p, "value", p.tracking);
          }
        }
        cb(self.deliveries);
      });
    },
    handleSelectDeliveryTracking(item) {
      const self = this;
      self.returnBack.deliverySerialNo = item.serialNo;
      self.returnBack.deliceryTracking = item.tracking;
    },
    // 发货单号
    querySearchDeliverySerialNo(queryString, cb) {
      const self = this;
      //
      if (queryString == null || queryString.length < 1) {
        return;
      }
      Delivery.vagueFindBySerialNo({ serialNo: queryString }).then(function (
        res
      ) {
        self.deliveries = res.data;
        if (self.deliveries.length !== 0) {
          for (const p of self.deliveries) {
            Vue.set(p, "value", p.serialNo);
          }
        }
        cb(self.deliveries);
      });
    },
    handleSelectDeliverySerialNo(item) {
      const self = this;
      self.returnBack.deliverySerialNo = item.serialNo;
      self.returnBack.deliceryTracking = item.tracking;
    },

    // 货号
    querySearchProductNo(queryString, cb) {
      const self = this;
      //
      if (queryString == null || queryString.length < 1) {
        return;
      }
      Product.vagueFindByProductNo({ productNo: queryString }).then(function (
        res
      ) {
        self.products = res.data;
        if (self.products.length !== 0) {
          for (const p of self.products) {
            Vue.set(p, "value", p.productNo);
          }
        }
        cb(self.products);
      });
    },
    handleSelectProductNo(item) {
      const self = this;
      self.returnBack.productNo = item.productNo;
      self.productNoColors = item.colors;
      self.productNoSizes = item.sizes;
    },

    // 颜色
    querySearchColor(queryString, cb) {
      const colors =
        this.productNoColors.length !== 0
          ? this.productNoColors.map((pc) => {
              return { value: pc };
            })
          : this.colors.map((c) => {
              return { value: c.name };
            });
      if (queryString == null) {
        cb(colors);
      } else {
        cb(colors.filter((c) => c.value.indexOf(queryString) !== -1));
      }
    },
    handleSelectColor() {
      this.returnBack.color = Util.jyTrim(this.returnBack.color);
    },
    // 规格
    querySearchSize(queryString, cb) {
      const self = this;
      let sizes = [];
      if (self.productNoSizes.length !== 0) {
        sizes = this.productNoSizes.map((pc) => {
          return { value: pc };
        });
      } else {
        if (self.categorySizes.length !== 0) {
          sizes = this.categorySizes.map((c) => {
            return { value: c.name, explain: c.explain };
          });
        } else {
          sizes = this.sizes.map((c) => {
            return { value: c.name, explain: c.explain };
          });
        }
      }
      if (queryString == null) {
        cb(sizes);
      } else {
        cb(sizes.filter((c) => c.value.indexOf(queryString) !== -1));
      }
    },
    handleSelectSize() {
      const self = this;
      self.returnBack.size = Util.jyTrim(self.returnBack.size);
    },

    //
    save() {
      let self = this;
      self.$refs.returnBackForm.validate((valid) => {
        if (valid) {
          if (
            !Util.regexQuantity(self.returnBack.quantity) ||
            self.returnBack.quantity === "0"
          ) {
            self.$message({
              message: self.$t("rules.regex", [self.$t("text.quantity")]),
              type: "warning",
            });
            return;
          }
          self.returnBack.color = Util.jyTrim(self.returnBack.color);
          self.returnBack.size = Util.jyTrim(self.returnBack.size);

          self.saveDoing = true;
          ReturnBack.create(self.returnBack).then(function (res) {
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.saveSuccess"),
                type: "success",
              });
              self.$router.push({ name: "toDoListsCustomerReturns" });
              self.$eventHub.$emit("returnBackCreate");
            } else {
              self.sysError();
            }
            self.saveDoing = false;
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.name {
  text-overflow: ellipsis;
  overflow: hidden;
}
.addr {
  font-size: 12px;
  color: #b4b4b4;
}
</style>